import { render, staticRenderFns } from "./PackageCardView.vue?vue&type=template&id=1f0a966e"
import script from "./PackageCardView.vue?vue&type=script&lang=js"
export * from "./PackageCardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports